<template>
  <ul class="ls-continent" role="listbox">
    <li role="option" class="ls-all" v-if="!hotelsOnly">
      <a @click="select($event, continent)" tabindex="0">{{
        inAllTab
          ? continent.title
          : $t("website.general.location.xHotelsInLocation", {
              count: $t("website.booking.panel_allHotels"),
              location: props.continent.title,
            })
      }}</a>
    </li>
    <li
      role="option"
      class="ls-city"
      v-for="(city, index2) in continent.cities"
      :key="`city_${index2}`"
    >
      <a
        v-if="!hotelsOnly"
        @click="select($event, city)"
        @keydown.enter.prevent="select($event, city)"
        @keydown.space.prevent="select($event, city)"
        tabindex="0"
        >{{ city.title }}</a
      >
      <span v-if="hotelsOnly">{{ city.title }}</span>
      <ul v-if="city.properties">
        <li v-for="(hotel, index3) in city.properties" :key="`hotel_${index3}`">
          <a
            @click="select($event, hotel)"
            @keydown.enter.prevent="select($event, hotel)"
            @keydown.space.prevent="select($event, hotel)"
            tabindex="0"
            >{{ hotel.title }}
            <Icon
              v-if="isHotelCrsEnabled(hotel.code)"
              name="foundation:external-link"
            />
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed } from "vue";
const { hotels } = useHotels();

const props = defineProps({
  allIn: {
    type: String,
    default: "all hotels in {loc}",
  },
  continent: {
    type: Object,
    required: true,
  },
  inAllTab: {
    type: Boolean,
    default: false,
  },
  hotelsOnly: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (
    e: "locationChange",
    payload: { id: string; title: string; type: string },
  ): void;
}>();

function select(e: Event, loc: { id: string; title: string; type: string }) {
  if (e) {
    e.preventDefault();
  }
  emit("locationChange", {
    id: loc.id,
    title: loc.title,
    type: loc.type,
  });
}

function isHotelCrsEnabled(hotelCode: string) {
  const hotelMatch = hotels.value.find(
    (hotel) => hotel.propertyCode === hotelCode,
  );
  return hotelMatch?.crsEnabled;
}
</script>

<style lang="scss">
/* stylelint-disable no-descending-specificity */

/* TODO: fix all the specificity issues */
.ls-continent {
  display: block;
  margin: 0;
  padding: 0;
  font-size: var(--font-size-small);
  line-height: var(--line-height-smaller);

  ul {
    padding: 0;
    list-style: disc;
  }

  + .ls-continent {
    margin-top: var(--space-32);
  }

  li,
  a {
    display: block;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }

  a {
    text-decoration: none;

    &:hover,
    &:focus {
      color: var(--primary-red);
      text-decoration: none;
    }
  }

  li {
    + li {
      margin-top: var(--space-8);
    }
  }

  a,
  span {
    + ul {
      margin-top: var(--space-8);
    }
  }
}

.ls-all {
  font-size: var(--font-size-smaller);
  line-height: var(--line-height-smaller);
}

.ls-city {
  > a,
  span {
    font-family: var(--font-family-bold);
  }

  + .ls-city {
    margin-top: var(--space-16);
  }
}
</style>
